import React from 'react'

import { FormHelperText, Switch } from '@mui/material'

import { ToggleMultiCheckboxProps } from '../../../ana-toolbox'
import { FormControlLabel } from '../../utils/shared/FormControlLabel'
import { ChecklistInput } from '../checklist-input/checklist-input'
import { Translate } from '../translate/translate'

import * as S from './toggle-multi-checkbox.styles'

export const ToggleMultiCheckbox = ({
  value,
  selectedValues = [],
  label,
  options = [],
  allowCustomOptions,
  onSelectedValuesChange,
  onToggleChange,
  helperText,
  error,
}: ToggleMultiCheckboxProps) => {
  const handleToggleChange = (e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    onToggleChange?.(e, checked)
  }

  return (
    <>
      <S.Container>
        <FormControlLabel
          label={<Translate>{label}</Translate>}
          control={<Switch checked={value} onChange={handleToggleChange} />}
          labelPlacement="start"
        />
      </S.Container>

      {value && (
        <ChecklistInput
          onChange={onSelectedValuesChange || (() => {})}
          selectedValues={selectedValues}
          options={options}
          allowCustomOptions={allowCustomOptions}
          error={error}
        />
      )}

      {error && (
        <FormHelperText error>
          <Translate>{error}</Translate>
        </FormHelperText>
      )}

      {helperText && (
        <FormHelperText>
          <Translate>{helperText}</Translate>
        </FormHelperText>
      )}
    </>
  )
}
